const strings = {
  CANCEL: 'Avbryt',
  DONE: 'Klar',
  INTERNAL_ERROR: 'Ett oväntat fel har uppstått, var god försök igen.',
  SETTING_UPDATED: 'Inställningen har uppdaterats',
  BOOKING_RANGE: 'Framtidsbokning',
  BOOKING_RANGE_INFO:
    'Ställ in hur många veckor in i framtiden man ska kunna boka.'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/EditBookingRangeModal/strings.js